<template>
  <div>
    <div
      id="modal-title"
      class="modal-header"
    >
      <h3>{{ $t('edit.queue') }}</h3>
    </div>
    <div class="modal-content">
      <!-- In case of: Edit Queue -->
      <form
        id="form-edit-queue"
        action
      >
        <div class="input-group">
          <div class="input input-text">
            <label for="queue-name-pt">{{ $t('name') }}</label>
            <input
              id="queue-name-pt"
              v-model="queue.name['pt']"
              type="text"
              placeholder="Insira o nome da fila"
              required
            >
          </div>
        </div>

        <div class="input-group">
          <div class="input input-text">
            <label for="queue-name-en">{{ $t('name') }} - {{ $t('english') }}</label>
            <input
              id="queue-name-en"
              v-model="queue.name['en']"
              type="text"
              :placeholder="$t('translate.queue.name')"
              required
            >
          </div>
        </div>

        <div class="form-actions">
          <button
            type="button"
            class="btn-secondary"
            @click="close"
          >
            {{ $t('cancel') }}
          </button>
          <button
            type="button"
            class="btn-primary btn-active main-action"
            @click="updateQueue()"
          >
            {{ $t('update') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import api from '@/api'

export default {
  name: 'EditQueue',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    serviceID: {
      type: String,
      required: true
    },
    queue: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      open: false,
      alphabet: []
    }
  },
  computed: {
    ...mapState(['service', 'currentTickets'])
  },
  async mounted () {
    this.alphabet = this.genCharArray('A', 'Z')
  },
  methods: {
    ...mapActions(['fetchService', 'fetchCurrentTickets']),
    async close () {
      this.$emit('input', false)
    },
    genCharArray (charA, charZ) {
      let a = []
      let i = charA.charCodeAt(0)
      let j = charZ.charCodeAt(0)
      for (; i <= j; ++i) {
        a.push(String.fromCharCode(i))
      }
      return a
    },
    async updateQueue () {
      await api.updateQueue({
        service: this.serviceID,
        queueSlug: this.queue.letter,
        queue: { name: this.queue.name }
      })
      this.fetchService(this.serviceID)
      this.open = false
      this.close()
    }
  }
}
</script>
